import React, { useState } from 'react';

const AddLeadModal = ({ open, onClose, onSubmit }) => {
  const [form, setForm] = useState({ name: '', company: '', value: '', tag: 'SaaS' });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
    setForm({ name: '', company: '', value: '', tag: 'SaaS' });
  };

  return (
    <div className={`modal-overlay ${open ? 'active' : ''}`} onClick={onClose} data-testid="add-lead-modal">
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-icon primary">+</div>
        <div className="modal-title">Tambahkan Lead Baru</div>
        <div className="modal-sub" style={{ marginBottom: '20px' }}>Masukkan informasi prospek ke dalam pipeline.</div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nama Prospek</label>
            <input type="text" className="form-control" required placeholder="Contoh: Budi Santoso"
              value={form.name} onChange={e => setForm({ ...form, name: e.target.value })}
              data-testid="add-lead-name" />
          </div>
          <div className="form-group">
            <label>Perusahaan</label>
            <input type="text" className="form-control" required placeholder="Contoh: PT. Maju Bersama"
              value={form.company} onChange={e => setForm({ ...form, company: e.target.value })}
              data-testid="add-lead-company" />
          </div>
          <div style={{ display: 'flex', gap: '16px' }}>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Estimasi Nilai</label>
              <input type="text" className="form-control" required placeholder="Rp 5,0M"
                value={form.value} onChange={e => setForm({ ...form, value: e.target.value })}
                data-testid="add-lead-value" />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Kategori (Tag)</label>
              <select className="form-control form-select" value={form.tag}
                onChange={e => setForm({ ...form, tag: e.target.value })}
                data-testid="add-lead-tag">
                <option value="SaaS">SaaS</option>
                <option value="Enterprise">Enterprise</option>
                <option value="Finance">Finance</option>
                <option value="Tech">Tech</option>
              </select>
            </div>
          </div>
          <div className="modal-actions">
            <button type="button" className="btn-modal btn-cancel" onClick={onClose} data-testid="add-lead-cancel">Batal</button>
            <button type="submit" className="btn-modal btn-gold" data-testid="add-lead-submit">Simpan Lead</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddLeadModal;
